import {
  TOGGLE_RIGHT_DRAWER, TOGGLE_RIGHT_DRAWER_TAB, TOGGLE_RIGHT_DRAWER_FIRST_TAB,
} from '../../../constants/system/actions';

const toggleRightDrawer: Function = (payload?: boolean): ReduxAction => ({
  type: TOGGLE_RIGHT_DRAWER, payload,
});

const toggleRightDrawerTab: Function = (payload?: boolean): ReduxAction => ({
  type: TOGGLE_RIGHT_DRAWER_TAB, payload,
});

const toggleRightDrawerFirstTab: Function = (payload?: boolean): ReduxAction => ({
  type: TOGGLE_RIGHT_DRAWER_FIRST_TAB, payload,
});

export {
  toggleRightDrawer,
  toggleRightDrawerTab,
  toggleRightDrawerFirstTab,
};
